module.exports = __webpack_public_path__ + "static/media/BA.c1aa67ba.png";